import { AbstractControl } from '@angular/forms';

export function shouldDisplayValidationPendingMessage(formControl: AbstractControl): boolean {
  return formControl.dirty;
}
